export const WORK_CALENDAR = 'WorkCalendar';
//# sourceMappingURL=work-calendar.js.map